import React from 'react';

import styles from '../../../../utils/styles';
import { TypographyElements } from '../../../foundation';

import './VideoInfoStatus.scss';

export type VideoInfoStatusType = 'playing' | 'accessRequired' | 'not-playing';

export interface IVideoInfoStatus {
  type: VideoInfoStatusType;
  isHidden?: boolean;
}

const textMapping = Object.freeze({
  playing: 'IN RIPRODUZIONE',
  accessRequired: 'UTENTI REGISTRATI',
});

const VideoInfoStatus: React.FC<IVideoInfoStatus> = ({ type, isHidden = true }) => {
  const className = styles('video-info-status', isHidden && 'video-info-status--hidden');
  return (
    <div className={className}>
      {textMapping[type] && (
        <TypographyElements text={textMapping[type]} typographyClass="ty-elements-medium--uppercase" />
      )}
    </div>
  );
};

export default VideoInfoStatus;
